import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import updateCohortSharingState from '../sharing/state/cohortSharing';
import updateFiltersState from '../filters/state/cohortFilters';
import updateCohortQueriesState from '../queries/state/cohortQueries';
import updateClausesState from '../clauses/state/cohortClauses';
import updateVisualisationState from '../visualisations/state/cohortVisualisations';
import updateProfileState from '../profile/state/cohortProfile';
import updateCohortsState from './cohort';
import updateSystemCohortState from '../system/state/systemCohort';

const handlers = {
  ...updateCohortsState,
  ...updateCohortSharingState,
  ...updateFiltersState,
  ...updateCohortQueriesState,
  ...updateClausesState,
  ...updateVisualisationState,
  ...updateProfileState,
  ...updateSystemCohortState,
};

export default (state = initialState, action) => chooseReducer(state, action, handlers);
